import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        token: String,
        formName: String,
        contactExistsRoute: String,
    };

    connect() {
        const $form = $('[name="' + this.formNameValue + '"]');

        let contactExists = false;
        let contactCheckTimeout = null;
        let submitAttempted = false;

        const checkContactExistsAndMaybeSubmit = () => {
            $.post(this.contactExistsRouteValue, { token: this.tokenValue })
                .done(function(response) {
                    contactExists = response.exists === true;

                    if (contactExists && submitAttempted) {
                        $form.off('submit');
                        $form.submit();
                    } else if (submitAttempted) {
                        contactCheckTimeout = setTimeout(checkContactExistsAndMaybeSubmit, 5000);
                    }
                })
                .fail(function() {
                    contactExists = false;

                    if (submitAttempted) {
                        contactCheckTimeout = setTimeout(checkContactExistsAndMaybeSubmit, 5000);
                    }
                });
        };

        $form.on('submit', function(event) {
            showPreloader();
            event.preventDefault();
            clearTimeout(contactCheckTimeout);

            submitAttempted = true;
            checkContactExistsAndMaybeSubmit();
        });
    }
}

